function pick(v) {
  var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return fields.reduce(function (datum, field) {
    // Pick the data deeply.
    if (field in v) {
      datum[field] = v[field];
    }
    return datum;
  }, {});
}
/**
 * Immutable data pick by specified fields.
 */
export var Pick = function Pick(options) {
  var fields = options.fields;
  return function (data) {
    return data.map(function (d) {
      return pick(d, fields);
    });
  };
};
Pick.props = {};